import { ICartMetadataModel, IInstallmentPlanModel, IProductModel } from '../../models';
import { Installments } from 'components/Cart/OrderSummary/types';
import { TFunction } from 'i18next';

export const getSoftwarePlanMonthlyPrice = (
  installmentPlans: IInstallmentPlanModel[],
  selectedPurchaseType: Installments,
) => {
  const selectedPlan = installmentPlans.find(plan => plan.id === selectedPurchaseType);
  return selectedPlan ? selectedPlan.cost : undefined;
};

export const generateCartAccessories = (
  accessories: IProductModel[],
  tryRemoveProductById: (product: IProductModel) => void,
) => {
  return accessories.map(accessory => ({
    product: accessory,
    removeProductById: () => tryRemoveProductById(accessory),
  }));
};

export const generateHeading = (cartMetadata?: ICartMetadataModel | null, t?: TFunction<any, any>) => {
  return cartMetadata?.solutionTitle
    ? t('cart-page.heading-with-solution-title', {
        solutionTitle: cartMetadata.solutionTitle,
        bundleName: cartMetadata.name,
      })
    : cartMetadata?.name;
};
